import { gql } from '@apollo/client';
import { useCallback } from 'react';
import type { UseSeriesPolicyCheck_SeriesFragment } from '../graphql/generated/graphqlTypes';
import { PostPolicyAction, usePostPolicyCheck } from '../post/postPolicyCheck';
import type { UserRole } from '../topic/topicPolicyCheck';

export enum SeriesPolicyAction {
  EditSeries,
}

const USE_SERIES_POLICY_CHECK_POST_FRAGMENT = gql`
  fragment useSeriesPolicyCheck_post on Post {
    ...usePostPolicyCheck_post
  }
  ${usePostPolicyCheck.fragments.post}
`;

const USE_SERIES_POLICY_CHECK_SERIES_FRAGMENT = gql`
  fragment useSeriesPolicyCheck_series on PublicSeriesFields {
    ... on Series {
      posts {
        ...useSeriesPolicyCheck_post
      }
    }
  }
  ${USE_SERIES_POLICY_CHECK_POST_FRAGMENT}
`;

const useSeriesPolicyCheck = () => {
  const postPolicyCheck = usePostPolicyCheck();
  return useCallback(
    (
      action: SeriesPolicyAction,
      series: UseSeriesPolicyCheck_SeriesFragment,
      user: UserRole | { id: string },
    ) => {
      switch (action) {
        case SeriesPolicyAction.EditSeries:
          return (
            'posts' in series &&
            (series.posts.length === 0 ||
              series.posts.some((post) =>
                postPolicyCheck(PostPolicyAction.EditPost, post, user),
              ))
          );
        default:
          return false;
      }
    },
    [postPolicyCheck],
  );
};

useSeriesPolicyCheck.fragments = {
  series: USE_SERIES_POLICY_CHECK_SERIES_FRAGMENT,
  post: USE_SERIES_POLICY_CHECK_POST_FRAGMENT,
};

export default useSeriesPolicyCheck;
